import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { articles } from "@/data/articles";

export default function PillarArticles() {
  const { t } = useTranslation();
  const { lang } = useParams();

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            {t("pillars.title")}
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto">{t("pillars.subtitle")}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {articles.map((a) => (
            <Link
              key={a.slug}
              to={`/${lang}/article/${a.slug}`}
              className="group rounded-lg border border-background-200 bg-background-50 overflow-hidden hover:border-primary-300 transition flex flex-col"
            >
              <div className="relative h-36 overflow-hidden">
                <img
                  src={a.image}
                  alt={a.title}
                  title={a.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 text-primary-700 text-[11px] font-semibold whitespace-nowrap">
                  {a.eyebrow}
                </span>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 leading-snug mb-2 line-clamp-2">
                  {a.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 mb-3">{a.excerpt}</p>
                <span className="mt-auto inline-flex items-center gap-1.5 text-sm font-semibold text-primary-700 group-hover:gap-2.5 transition-all">
                  {t("pillars.readMore")}
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}